import { defineComponent } from 'vue';
import { PresetSettingsButtonName } from '@/models/preset-settings/preset-settings.model';
import {
  Back,
} from '@element-plus/icons-vue';

const icons = {
  Back,
};

export default defineComponent({
  name: 'SettingsScreenHeader',
  props: {
    selectedCountryName: {
      type: String,
      required: true,
    },
    isSaveButtonDisabled: {
      type: Boolean,
      required: true,
    },
    isLoading: {
      type: Boolean,
      required: true,
    },
  },
  emits: ['close', 'submit'],
  setup() {
    return {
      PresetSettingsButtonName,
      icons,
    };
  },
});
